<script>
  import {onMount} from 'svelte';
  import HeaderWrapper from '../wrappers/HeaderWrapper.svelte';
  import ContentWrapper from '../wrappers/ContentWrapper.svelte';
  import ButtonsWrapper from '../wrappers/ButtonsWrapper.svelte';
  import CloseIcon from '../elements/CloseIcon.svelte';
  import Button from '../elements/Button.svelte';
  import Collapse from '../elements/Collapse.svelte';
  import Vendor from '../elements/Vendor.svelte';
  import {_} from '../../translations';
  import {getVendorsWithUrls} from '../../vendors';
  import {PAGE_PURPOSES, USER_INT, USER_EXT} from '../../constants';
  import {logger} from '../../services/logger';

  export let userType = '';
  export let formData = {};
  export let submiting = false;
  const defaultVendors = [...formData.vendors];
  $: vendors = defaultVendors;

  const onChangeUpdateFormData = ({target}) => {
    const id = Number(target.value);
    const {checked} = target;

    logger(500, `Vendor with id "${id}" has checked: ${checked}.`);
    formData.vendors = formData.vendors.map(vendor => (vendor.id === id ? {...vendor, checked} : vendor));
  };

  onMount(() => {
    getVendorsWithUrls(defaultVendors)
      .then(vendorList => {
        vendors = vendorList;
      })
      .catch(e => console.error(e));
  });
</script>

<CloseIcon on:exit screen={3} />
<div class="scmp_Scrollable-content-wrapper">
  <HeaderWrapper>
    <h2 class="scmp_SectionTitle">{_('vendors.title')}</h2>
    <p class="scmp_Paragraph">
      {#if userType === USER_INT}
        {@html _('vendors.description')}
      {/if}
      {#if userType === USER_EXT}
        {@html _('vendors.externalDescription')}
      {/if}
    </p>
    <Collapse openText={_('button.purposes')}>
      {@html _('vendors.details')}
    </Collapse>
  </HeaderWrapper>

  <ContentWrapper>
    <div class="scmp_Vendors">
      {#each vendors as vendor}
        <Vendor on:change={onChangeUpdateFormData} {vendor} />
      {/each}
    </div>

    <p class="scmp_VendorsText">
      {@html _('vendors.help')}
    </p>
  </ContentWrapper>
</div>

<ButtonsWrapper>
  <Button on:buttonClick label={_('button.back')} navigation={PAGE_PURPOSES} type="back" />
  <Button on:buttonClick disabled={submiting} screen={3} label={_('button.confirm')} type="submit" />
</ButtonsWrapper>
